import React, {Component} from 'react'

export default ({open, modal}) => open && modal || null
